/* Silumen i18n : traduction d'affichage des widgets JS (formulaire SAV).
   Traduit les nœuds texte et les attributs placeholder/title/aria-label/alt dont le texte
   FR existe dans le dictionnaire window.SMT_I18N (assets/smt-i18n-<langue>.js).
   Les données ne changent pas : les <option> gardent leur valeur FR, les <textarea>,
   champs saisis et scripts ne sont jamais touchés. Sans dictionnaire (FR), ne fait rien. */
(function () {
  var script = document.currentScript;
  var rootId = script && script.getAttribute('data-smt-root');
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, CODE: 1, NOSCRIPT: 1, INPUT: 1, SELECT: 0 };
  var ATTRS = ['placeholder', 'title', 'aria-label', 'alt'];
  var map = null, keys = null, obs = null;

  function norm(s) { return String(s).replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); }

  function build() {
    var d = window.SMT_I18N, n = 0;
    map = {};
    for (var k in d) {
      if (Object.prototype.hasOwnProperty.call(d, k)) { map[norm(k)] = d[k]; n++; }
    }
    keys = Object.keys(map).filter(function (x) { return x.length >= 6; }).sort(function (a, b) { return b.length - a.length; });
    return n;
  }

  /* Texte composé de plusieurs morceaux connus (chaînes concaténées par le JS) :
     on traduit de gauche à droite le plus long morceau connu en tête. */
  function segment(k) {
    if (k.length < 20) return null;
    var out = [], rest = k, changed = false, guard = 0;
    while (rest && guard++ < 40) {
      var hit = null;
      for (var i = 0; i < keys.length; i++) {
        var kk = keys[i];
        if (kk.length <= rest.length && rest.lastIndexOf(kk, 0) === 0) {
          var nx = rest.charAt(kk.length);
          if (!nx || /[\s.,;:!?)\u00bb]/.test(nx)) { hit = kk; break; }
        }
      }
      if (!hit) { out.push(rest); break; }
      out.push(map[hit]); changed = true;
      rest = rest.slice(hit.length).trim();
    }
    return changed ? out.join(' ') : null;
  }

  function trText(node) {
    var p = node.parentNode;
    if (!p || SKIP[p.nodeName] || p.isContentEditable) return;
    var v = node.nodeValue, k = norm(v);
    if (!k) return;
    var t = map[k];
    if (t === undefined) t = segment(k);
    if ((t === undefined || t === null) && window.SMT_I18N_PAT) {
      /* motifs à variables, ex. « Étape 2 sur 5 · Votre question » */
      for (var i = 0; i < window.SMT_I18N_PAT.length; i++) {
        var re = new RegExp(window.SMT_I18N_PAT[i][0]), mm = k.match(re);
        if (mm) {
          var tail = k.slice(mm[0].length), tt = map[norm(tail)];
          if (tt === undefined) tt = segment(tail) || tail;
          t = k.slice(0, mm[0].length).replace(re, window.SMT_I18N_PAT[i][1]) + tt;
          break;
        }
      }
    }
    if (t === undefined || t === null || norm(t) === k) return;
    if (p.nodeName === 'OPTION' && !p.hasAttribute('value')) p.setAttribute('value', p.textContent);
    node.nodeValue = v.match(/^\s*/)[0] + t + v.match(/\s*$/)[0];
  }

  function trEl(el) {
    if (!el.getAttribute) return;
    for (var i = 0; i < ATTRS.length; i++) {
      var a = el.getAttribute(ATTRS[i]);
      if (a) {
        var t = map[norm(a)];
        if (t !== undefined && t !== a) el.setAttribute(ATTRS[i], t);
      }
    }
  }

  function walk(node) {
    if (node.nodeType === 3) { trText(node); return; }
    if (node.nodeType !== 1 || SKIP[node.nodeName]) return;
    trEl(node);
    var w = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT), c;
    while ((c = w.nextNode())) {
      if (c.nodeType === 3) trText(c);
      else if (!SKIP[c.nodeName]) trEl(c);
    }
  }

  function start() {
    if (!window.SMT_I18N || !build()) return;
    var root = (rootId && document.getElementById(rootId)) || document.body;
    walk(root);
    obs = new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var m = ms[i];
        if (m.type === 'characterData') trText(m.target);
        else if (m.type === 'attributes') trEl(m.target);
        else for (var j = 0; j < m.addedNodes.length; j++) walk(m.addedNodes[j]);
      }
      obs.takeRecords(); /* ignore nos propres modifications */
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
